import { render, staticRenderFns } from "./IconStarSolid.vue?vue&type=template&id=0d180ee2"
import script from "./IconStarSolid.vue?vue&type=script&lang=js"
export * from "./IconStarSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports